const bumiQuiz = [
    {
    question: "Bumi adalah planet ke berapa dari Matahari?",
    options: ["2", "3", "4", "5"],
    answer: 1,
  },
  {
    question: "Mengapa Bumi disebut sebagai planet yang mendukung kehidupan?",
    options: [
      "Karena sangat besar",
      "Karena memiliki air dan udara",
      "Karena dekat dengan Matahari",
      "Karena berwarna biru",
    ],
    answer: 1,
  },
  {
    question: "Sebagian besar permukaan Bumi ditutupi oleh?",
    options: ["Hutan", "Gurun", "Air", "Es"],
    answer: 2,
  },
  {
    question: "Lapisan gas yang menyelimuti Bumi disebut?",
    options: [
      "Litosfer",
      "Atmosfer",
      "Hidrosfer",
      "Biosfer",
    ],
    answer: 1,
  },
  {
    question: "Berapa lama waktu yang dibutuhkan Bumi untuk berotasi?",
    options: ["12 jam", "24 jam", "30 hari", "365 hari"],
    answer: 1,
  },
  {
    question: "Perputaran Bumi mengelilingi Matahari disebut?",
    options: [
      "Rotasi",
      "Revolusi",
      "Orbit",
      "Gravitasi",
    ],
    answer: 1,
  },
  {
    question: "Satelit alami Bumi adalah?",
    options: [
      "Mars",
      "Venus",
      "Bulan",
      "Matahari",
    ],
    answer: 2,
  },
  {
    question: "Lapisan Bumi tempat makhluk hidup tinggal disebut?",
    options: [
      "Atmosfer",
      "Litosfer",
      "Biosfer",
      "Inti Bumi",
    ],
    answer: 2,
  },
  {
    question: "Apa penyebab terjadinya siang dan malam?",
    options: [
      "Revolusi Bumi",
      "Rotasi Bumi",
      "Gerhana Matahari",
      "Pasang surut",
    ],
    answer: 1,
  },
  {
    question: "Bumi memiliki berapa benua?",
    options: ["5", "6", "7", "8"],
    answer: 2,
  },
]

export default bumiQuiz